export default "__VITE_ASSET__429b929a__"